import Request from './http-request';
import config from './config';

import {
    remove_user
} from '../../stores/user';
import lib from './lib';

const Helpers = {};

// get header config
Helpers.getHeaderConfig = (token) => {
    return { headers: { 'Authorization': `Bearer ${token}` } }
};

// get header config
Helpers.getHeaderAccessControl = () => {
    return { headers: { 'Access-Control-Allow-Origin': '*' } }
};


// Add use to the store state
Helpers.loadUserInStore = (user) => {
    // dispatcher({type: Actions.user.set, payload: { user }});
};

// Get user from local storage
Helpers.GetUserFromStorage = () => {
    const key = config.key.user;
    const json = localStorage.getItem(key);
    // userData
    try {
        if (json && json !== null) {
            return JSON.parse(json);
        }
    } catch (e) {
        return null;
    }
};

// Add user to local storage
Helpers.SetUserInStorage = (user, set) => {
    set(user);
};

// Remove user data from local storage
Helpers.RemoveUserFromStorage = (set) => {
    set(null)
};

// Add use to the store state
Helpers.logout = (set, dispatcher) => {
    dispatcher(remove_user)
    set(null)
};

/**
 * authenticate user
 */
Helpers.signin = async (data) => {
    return await (await Request.post(config.api.login, data)).data.data;
}

/**
 * clear session if token has expired 
 */
Helpers.sessionHasExpired = (set, msg, setError) => {
    if (msg?.toUpperCase() === 'UNAUTHENTICATED') {
        Helpers.logout(set);
    } else {
        if (typeof setError === 'function') {
            setError(msg);
        }
    }
}

// Get error message from Http request
Helpers.GetHttpRequestErrorMsg = (e) => {
    return e?.response?.data?.err[0]
        || e?.response?.data?.msg
        || e?.message;
}

// Handles http request error message
Helpers.errorHandler = (set, e, notifications) => {
    const msg = Helpers.GetHttpRequestErrorMsg(e);
    if (msg?.toUpperCase() === "UNAUTHENTICATED") {
        Helpers.logout(set)
        return;
    }
    if (notifications) {
        Helpers.alert({ notifications, icon: 'error', message: msg, color: 'red' })
    }
}

/**
 * icon - success | error
 * color - green | red
 * message - message
 */
// Helpers.alert = ({notifications, icon, color, message }) => {
//     notifications.showNotification({
//         title: 'Notification',
//         icon: icon === 'success' ? <CheckCircledIcon /> : <CrossCircledIcon />,
//         color: color || 'green',
//         message,
//     });
// }


export const NullSafe = (data) => {
    return data?.map(c => {
        const this_dat = {};
        Object.entries(c).forEach(col => {
            this_dat[col[0]] = col[1] || '';
        })
        return this_dat;
    })
}

export function thereIsAnyEmptyField(obj) {
    return Object.values(obj).some(val => val === undefined || val === null || val === '');
}

// export function keysHaveEmptyValues(obj, keysArray) {
//     const result = keysArray.every(key => obj.hasOwnProperty(key) && obj[key] !== undefined && obj[key] !== null && obj[key] !== "");
//     console.log(result);
//     return result;
// }

export function keysHaveEmptyValues(obj, keysArray) {
    for (let i of keysArray) {
        if (!obj.hasOwnProperty(i) || !obj[i])
            return true;
    }
    return false;
}

export function hasEmptyEntries(obj) {
    return Object.entries(obj).some(([key, value]) => value === "");
}

export function validateEmailDomain(email, domain = 'amanhmo.com') {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
        return { isValid: false, error: 'Invalid email format' };
    }

    const emailDomain = email.split('@')[1].toLowerCase();

    if (emailDomain !== domain.toLowerCase()) {
        return { isValid: false, error: `Email does not match the domain ${domain}` };
    }

    return { isValid: true };
}

export async function downloadFile(url, filename) {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Error: ${response.statusText}`);
    const blob = await response.blob();
    const link = Object.assign(document.createElement('a'), {
        href: URL.createObjectURL(blob),
        download: filename
    });
    link.click();
    URL.revokeObjectURL(link.href);
    return { success: true, message: 'Downnload Completed' }
}

export function same(data, n_data, strict = true) {
    if (data == null || n_data == null) return data === n_data;
    if (strict && Object.keys(data).length !== Object.keys(n_data).length) return false;

    const vn = Object.entries(n_data).filter(([key, value]) => value !== data[key]);
    return vn.length === 0;
}

export const enrolleeListCommand = async (record) => {
    let payload = {
        policy_no: record?.policy_no
    }

    return lib.enrollees(payload)
        .then(resp => resp?.data)
        .then(respData => respData?.data)
        .then(data => {
            return data
        })
        .catch(error => {
            notification.error({
                message: error?.message || error?.msg
            })
            return []
        })
        .finally(() => [])
}

export const validateFacilitiesInState = (stateHealthCare, n_data) => {
    const isPrimaryInState = stateHealthCare?.some(facility =>
      facility?.facility_state === n_data?.state &&
      facility?.facility_name === n_data?.primary_health_facility
    );
  
    const isSecondaryInState = stateHealthCare?.some(facility =>
      facility?.facility_state === n_data?.state &&
      facility?.facility_name === n_data?.secondary_health_facility
    );
  
    // Check if both facilities are either in the same state or empty
    if (
      (!n_data?.primary_health_facility || isPrimaryInState) &&
      (!n_data?.secondary_health_facility || isSecondaryInState)
    ) {
      return true; // Validation passed
    } else {
      return false; // Validation failed
    }
  };
  

export default Helpers;